import {
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

import { startWith } from 'rxjs';

import { mapUserSelectOptions, UserSelectDataService } from '@core/account-ui';
import { BasicMultiSelectComponent, type SelectOption } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-user-multi-select-container',
  imports: [BasicMultiSelectComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './user-multi-select-container.component.html',
})
export class UserMultiSelectContainerComponent {
  private readonly usersData = inject(UserSelectDataService);
  private readonly destroyRef = inject(DestroyRef);

  public control = input.required<FormControl<number[]>>();
  public isInvalid = input<boolean>(false);
  public isReadOnly = input<boolean>(false);

  public selectedOptions = output<SelectOption[]>();

  public allUsers = toSignal(this.usersData.getUsers(), { initialValue: [] });

  public userOptions = computed(() => this.allUsers().map(user => mapUserSelectOptions(user)));

  protected ngOnInit(): void {
    this.control()
      .valueChanges.pipe(startWith(this.control().value), takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        const selectedOptions = value
          .map(userId => this.allUsers().find(user => user.id === userId))
          .filter(option => !!option);
        this.selectedOptions.emit(
          selectedOptions.map(user => ({
            value: user.id,
            label: `${user.firstName} ${user.lastName}`,
          })),
        );
      });
  }
}
